import { Typography } from "@mui/material";
import TimeUtilization from "components/time-utilization/TimeUtilization";
import { Family, FamilyStatus } from "protogen/advisors_service_pb";
import { PlanUtilization } from "protogen/common_pb";
import { shortDate } from "common/utils";
import FlexBox from "components/common/FlexBox";
import { useLocation, useNavigate } from "react-router-dom";

export default ({
  family,
  planUtilization,
  flex,
}: {
  family: Family;
  planUtilization: PlanUtilization;
  flex: number;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const onClick = () => {
    const pathname = location.pathname;
    // Parse the current search params
    const searchParams = new URLSearchParams(location.search);
    // Update the parameter value
    searchParams.set("currentMonth", "1");

    // Construct the new URL
    const newUrl = `${pathname}?${searchParams.toString()}#tab-settings`;

    // Navigate to the new URL
    navigate(newUrl);
  };
  return (
    <FlexBox variant="contained" sx={{ flex: flex }}>
      <FlexBox direction="column">
        <Typography variant="h4" gutterBottom>
          Family snapshot
        </Typography>
        {family.status === FamilyStatus.PROSPECT && (
          <FlexBox direction="column" gap="4px">
            <Typography color="#B85700" variant="bodyHeavy">
              Status: Prospect
            </Typography>
            <Typography variant="body" color="#B85700">
              This family hasn’t yet completed their onboarding profile.
              Encourage the client to finish signing up.
            </Typography>
          </FlexBox>
        )}

        {family.status !== FamilyStatus.DEACTIVATED &&
          family.status !== FamilyStatus.DIGITAL_DEACTIVATED &&
          family.status !== FamilyStatus.DIGITAL_DEACTIVATED_TRIAL && (
            <FlexBox>
              <TimeUtilization
                planUtilization={planUtilization}
                onClick={onClick}
                serviceEnding={!!family?.endDate}
              />
            </FlexBox>
          )}

        {/* Lifetime totals */}
        {family.status !== FamilyStatus.PROSPECT && (
          <FlexBox direction="column" gap="4px">
            <Typography variant="bodyHeavy">Lifetime totals</Typography>
            <Typography variant="body" color="text.secondary">
              {planUtilization.allTimeTasksCompleted && (
                <Typography variant="body">
                  {planUtilization.allTimeTasksCompleted} completed tasks
                </Typography>
              )}
            </Typography>
            <Typography variant="body" color="text.secondary">
              {family.startDate && (
                <Typography variant="body">
                  Member since {shortDate(family.startDate)}
                </Typography>
              )}
            </Typography>
          </FlexBox>
        )}

        {/* <Box sx={{ display: "flex", alignItems: "center", mb: "8px" }}>
        <CheckCircleOutlineIcon color="success" sx={{ mr: "8px" }} />
        <Typography variant="body2" color="success.main" fontWeight={600}>
            Status: Good
        </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
        This family is [insert criteria for a healthy family relationship]
        </Typography> */}
      </FlexBox>
    </FlexBox>
  );
};
